export enum CmaLiteCarriersConfiguration {
    ALL_CARRIERS = 'ALL_CARRIERS',
    SPECIFIC_CARRIERS = 'SPECIFIC_CARRIERS'
}